__turbopack_context__.v({
  "inner": "RiskDiagnosis-module-scss-module__nVnaMa__inner",
  "riskCard": "RiskDiagnosis-module-scss-module__nVnaMa__riskCard",
  "riskCardAvatar": "RiskDiagnosis-module-scss-module__nVnaMa__riskCardAvatar",
  "riskCardAvatarInner": "RiskDiagnosis-module-scss-module__nVnaMa__riskCardAvatarInner",
  "riskCardBody": "RiskDiagnosis-module-scss-module__nVnaMa__riskCardBody",
  "riskCardEmoji": "RiskDiagnosis-module-scss-module__nVnaMa__riskCardEmoji",
  "riskCardHeader": "RiskDiagnosis-module-scss-module__nVnaMa__riskCardHeader",
  "riskCardInfo": "RiskDiagnosis-module-scss-module__nVnaMa__riskCardInfo",
  "riskCardQuestion": "RiskDiagnosis-module-scss-module__nVnaMa__riskCardQuestion",
  "riskCardQuestionText": "RiskDiagnosis-module-scss-module__nVnaMa__riskCardQuestionText",
  "riskCardStory": "RiskDiagnosis-module-scss-module__nVnaMa__riskCardStory",
  "riskCardStoryBlock": "RiskDiagnosis-module-scss-module__nVnaMa__riskCardStoryBlock",
  "riskCardSubject": "RiskDiagnosis-module-scss-module__nVnaMa__riskCardSubject",
  "riskCardTitleText": "RiskDiagnosis-module-scss-module__nVnaMa__riskCardTitleText",
  "riskCardTop": "RiskDiagnosis-module-scss-module__nVnaMa__riskCardTop",
  "riskCards": "RiskDiagnosis-module-scss-module__nVnaMa__riskCards",
  "riskCardsList": "RiskDiagnosis-module-scss-module__nVnaMa__riskCardsList",
  "riskContent": "RiskDiagnosis-module-scss-module__nVnaMa__riskContent",
  "riskDiagnosis": "RiskDiagnosis-module-scss-module__nVnaMa__riskDiagnosis",
  "wrap": "RiskDiagnosis-module-scss-module__nVnaMa__wrap",
});
